

import Media from "./shared/media.js";
import Api from "./shared/api.js";
import listeners from './shared/listeners.js'
import f from './shared/functions.js'
import user from './shared/user.js'
import Sync from './shared/sync.js'

import Vueapi from './vueapi.js'
import Cordovakit from './shared/cordovakit.js'
import FX from './shared/utils/fx.js'
import { LSSettings } from "./shared/settings.js";


import Activity from "./lib/common/activity.js"
import Images from "./shared/utils/images.js";
import Authways from "./shared/utils/authways.js";

import Chats from './shared/chats.js'

var pkg = require('../../package.json')

var settings = {
    local: {
        UI: {
            listcontrols_courses : {
                name: 'listcontrols_courses',
                default: function() {
                    return {
                        sortvalue : null,
                        date : [],
                        searchvalue : '',
                        payloadsSample : ''
                    }
                },
            }
        },
        interface: {
            animatedBackground: {
                name: 'animatedBackground',
                default: function () {
                    return true
                },
            },
            
            emoji: {
                name: 'emoji',
                default: function () {
                    return true
                },
            },

            particles: {
                name: 'particles',
                default: function () {
                    return true
                },
            },

            pastel: {
                name: 'pastel',
                default: function () {
                    return false
                },
            },

            interfacelocale : {
                name: 'interfacelocale',
                default: function () {
                    return 'inherrit'
                },
            }
        }
    }
}

class Core {

    clbks = {}

    appid = 'app.snippity'

    apkAutoUpdaterName = 'snippity.apk'

    package = pkg

    metasettings = settings

    constructor(vm, p) {
        if (!p) p = {}

        this.vxstorage = p.vxstorage
        this.i18n = p.i18n
        this.appInfo = {}

        this.apiHandlers = {
            error: function () { },
            success: function () { }
        }


        this.domain = p.domain
        this.vm = vm

        this.api = new Api(this, "snippity")

        this.onlineListener = new listeners.online(this)
        this.focusListener = new listeners.focus(this)

        this.online = true
        this.focus = true
        this.store = vm.$store
        this.loading = true

        this.media = new Media()

        this.fx = new FX(this)
        this.cordovakit = new Cordovakit(this)
        this.vueapi = new Vueapi(this)
        this.sync = new Sync(this)
        this.chats = new Chats(this)

        this.settings = {
            interface: new LSSettings(this, "interface", settings.local),
            ui: new LSSettings(this, "UI", settings.local)
        }

        this.user = new user(this, {

            prepare: () => {

                return Promise.all(_.filter([

                    this.activity.load()
                
                ], (o) => {
                    return o
                })).catch(e => {
                    return Promise.reject(e)
                })

            },

            clearing: () => {

                this.api.clearCache()

                this.vxstorage.clear()

                this.store.commit('clearall')

                try{
                    localStorage['ppi'] = ''
                }catch(e){

                }
                

            },

            core : this

        })

        this.authways = new Authways(this)

        this.activity = new Activity(this)

        this.authways.init()

        this.chats.init()

        this.api.prepare().then(() => {
            return this.api.app.info() 
        }).then((info) => {

            this.appInfo = info

            this.store.commit('appinfo', {...info})

            this.user.init()
        }).catch(e => {
            console.error(e)
        })

    }

    setLS = function(key, object){
        try{
            localStorage[key] = JSON.stringify({date : new Date(), object : this.toJson(object)})
        }catch(e){
            console.error(e)
        }
    }

    getLS = function(key){
        try{
            if(localStorage[key]){
                var dob = JSON.parse(localStorage[key])
                
                return this.fromJson(dob.object)
            }
        }catch(e){
            console.error(e)
        }

        return null
    }

    on = function (event, key, f) {
        if (!this.clbks[event]) this.clbks[event] = {}

        this.clbks[event][key] = f
    }

    off = function (event, key) {
        if (!this.clbks[event]) this.clbks[event] = {}

        delete this.clbks[event][key]
    }

    emit = function (event, data) {
        if (!this.clbks[event]) this.clbks[event] = {}

        _.each(this.clbks[event], (c) => {
            c(data)
        })
    }

    logerror = function (type, data) {

        if (window.Logger) {

            window.Logger.error({
                err: type,
                payload: data,
                code: 402,
            });

        }
    }

    mobileview = function () {
        return window.innerWidth <= 768
    }

    destroy = function () {
        this.store.commit('clearall')

        this.chats.destroy()

        this.removeEvents()

        this.vm.$destroy();

    }

    init = function () {

        this.focusListener.init()
        this.onlineListener.init()

        this.initEvents()

    }


    setUnauthorized = function (v) {
        this.unauthorized = v
        this.store.commit('SET_UNAUTHORIZED', v)
    }

    initWithUserBase = function () {
        return Promise.resolve()
    }

    initWithUser = function (credentials) {
        return this.initWithUserBase()
    }

    waitonline = function () {

        if (this.online) return Promise.resolve()

        return new Promise((resolve, reject) => {

            f.retry(() => {
                return this.online;
            }, function () {

                resolve()

            }, 20)

        })

    }


    removeEvents = function () {
        delete this.focusListener.clbks.resume.core
        delete this.focusListener.clbks.pause.core
        delete this.onlineListener.clbks.online.core
        delete this.onlineListener.clbks.offline.core

        document.removeEventListener("drop", this.dropFiles)
    }

    initEvents = function () {
        this.focusListener.clbks.resume.core = (time) => {

            this.focus = this.focusListener.focus

            if (storywaspaused){
                storywaspaused.play()
                storywaspaused = null
            }

            if (time > 60 && window.cordova) {
                this.sync.stop()
            }

            this.cordovakit.purchases.onResume()
        }

        var storywaspaused = null

        this.focusListener.clbks.pause.core = () => {
            this.focus = this.focusListener.focus

            if ((f.isMobile() || f.isTablet()) && this.store.state.playingstory){

                storywaspaused = this.store.state.playingstory

                this.store.state.playingstory.pause()
            }
        }   

        this.onlineListener.clbks.online.core = (time) => {
            this.online = this.onlineListener.online
        }

        this.onlineListener.clbks.offline.core = () => {
            this.online = this.onlineListener.online
        }

        /*if(typeof document != 'undefined'){
            document.addEventListener("drop", this.dropFiles.bind(this))
            document.addEventListener("dragover", event => {
                event.preventDefault()
            })
        }*/

        
    }

    dropFiles = function (event) {
        event.preventDefault()

        var files = []

        _.each(event.dataTransfer.files, (F) => {
            files.push(F)
        })

        //this.store.commit('uploading', files)
    }

    currentTime = function () {
        var created = Math.floor((new Date().getTime()) / 1000)

        if (this.timeDifference) {
            created += this.timeDifference
        }

        return created;
    }

    wait = function () {
        return f.pretry(() => {
            return !this.loading
        }).then(() => {

            return Promise.resolve()

        })
    }

    gotoRoute(route) {
        this.cancelDefaultRoute = true;
        this.vm.$router.push(route).catch(e => { })
    }

    updateUser() {

    }

    parental(type, meta = {}, success, ifcase, failed){

        var metas = {
            'openlink' : {
                message: this.vm.$t("parental.meta.open_link"),
            },
            'subscription' : {
                message: this.vm.$t("parental.meta.payment"),
            },

            'removeuser' : {
                message: this.vm.$t("parental.meta.removeuser")
            }
        }

        if(ifcase && typeof ifcase == 'function' && ifcase()){
            return success()
        }

        if(window.cordova && typeof ParentalPermission != 'undefined' && ParentalPermission && metas[type]){

            this.user.state.is().then(state => {
                if(!state){
                    return success()
                }

                var email = self.user.info?.userinfo?.email

                if(!email){
                    return success()
                }

                this.store.commit('globalpreloader', true)

                ParentalPermission.request(email, 'emailaddress', type, {
                    ...metas[type],
                    ...meta,
                    title: this.vm.$t("parental.title"),
                },() => {

                    this.store.commit('globalpreloader', false)

                    success()
                },(err) => {

                    this.store.commit('globalpreloader', false)

                    sitemessage(this.vm.$t("parental.denied"))
                });
            })

            

        }
        else{
            //success()

            this.parentalPincode(success, '', failed)
        }
    }

    parentalPincode(success, caption = '', failed){
        var pin = localStorage['ppi'] || ''

        if(!pin){
            success()
        }

        else{

            this.vueapi.pincode('enter', 3, (code) => {

                if(code == pin){
                    return Promise.resolve()
                }

                return Promise.reject()
            }, caption).then(pin => {

                if(success) success()

            }).catch(e => {
                if(failed) failed()
            })
        }
    }

    sitemessage(title) {

        var position = "bottom-right";

        if (this.mobileview()) {
            position = 'top-left'
        }

        this.vm.$message({
            message: title,
            zIndex: 99999,
            supportHTML: true,
            wrapperClassName: "notificationWrapper",
            position: position,
            icon : 'fas fa-info-circle',
            type: 'info',
            duration: 2000
        })
    }

    menu(v) {

        this.store.commit('SET_MENU', v ? {
            items: v.items,
            item: v.item,
            handler: v.handler
        } : null)

    }

    action(path, data) {
        var action = f.deep(this, path)

        if (!action) {
            return Promise.reject({
                error: 'Action: ' + path
            })
        }
        else {
            return action(data)
        }
    }

    invalidateDb(dbIndex, updated, data) {
        return this.api.invalidateDb(dbIndex, updated, data).then((itemsId) => {

            _.each(itemsId, (id) => {
                this.emit('invalidate', {
                    [data.type]: id,
                    key: dbIndex
                })
            })
        })
    }

    filehandler(blob, p = {}) {

        if (!p.forcedownload) {

            if (blob.type.indexOf('image') > -1) {

                return f.Base64.blobToBase64(blob).then(b64 => {

                    var images = new Images()

                    return images.wh(b64).then(i => {

                        return this.vueapi.gallery([{
                            src: b64,
                            ...i
                        }])

                    })

                })

            }
        }


        return f.download(blob, p.name)

    }

    promwrapper = function(promise, settins = {}){

        this.store.commit('globalpreloader', true)

        return promise.then((d) => {

            if(!settins.hideicons){
                this.store.commit('icon', {
                    icon: 'success'
                })
            }

            
            
            return Promise.resolve(d)

        }).catch(e => {
            
            if(!settins.hideicons){
                this.store.commit('icon', {
                    icon: 'error',
                    message: this.vm.$t(e.error || "errors.general")
                })
            }

            return Promise.reject(e)

        }).finally(() => {
            this.store.commit('globalpreloader', false)
        })
    }


}

export default Core
